import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

export const getWorkflows = async websiteToken => {
  const urlData = endPoints.getWorkflows(websiteToken);
  return API.get(urlData.url, { params: urlData.params });
};

export const triggerWorkflow = async (websiteToken, workflowId) => {
  const referrerURL = window.referrerURL || '';
  const message = {
    timestamp: new Date().toString(),
    referer_url: referrerURL
  }
  const urlData = endPoints.triggerWorkflow(websiteToken, workflowId, message);
  return API.post(urlData.url,  urlData.data );
};
